import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import UserService from "../../services/user.service";
import ToastBlockContainer from "../../common/ToastBlockContainer";
import Loading from "../../common/Loading";

const AccountDowngradeSubscription = (props) => {
  let history = useHistory();
  let { uuid } = useParams();
  var UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [successToast, setSuccessToast] = useState(false);
  const [trialCheck, settrialCheck] = useState([]);
  const [trialCheck1, settrialCheck1] = useState([]);
  const [loading, setLoading] = useState(false);
  const [planNameVal, setPlanNameVal] = useState("");
  const [planIdVal, setPlanIdVal] = useState("");
  const [allFamilyUsers, setAllFamilyUsers] = useState([]);
  const [newArrayAU, setnewArrayAU] = useState([]);
  const [newArraySU, setnewArraySU] = useState([]);
  const [allValAU, setallValAU] = useState([]);
  const [allValSU, setallValSU] = useState([]);
  const [btnDisabled, setbtnDisabled] = useState(true);
  const [loader, setloader] = useState(false);
  console.log(props.location.state);
  const getFamilyDetails = () => {
    setLoading(true);
    UserService.getUserSingleFamilyDetails(uuid, UserDetails.id).then(
      (response) => {
        setPlanNameVal(
          response.FamilyData.Family.Family_Subscription
            .Account_Subscription_Plan.name
        );
        setPlanIdVal(
          response.FamilyData.Family.Family_Subscription
            .Account_Subscription_Plan.availableS
        );
        setTimeout(() => {
          setLoading(false);
        }, 500);
      }
    );
  };

  useEffect(() => {
    UserService.updateSUAURel(uuid).then((response) => {
      setAllFamilyUsers(response.data);
      var newArrAU = [];
      for (var i = 0; i < response.data.length; i++) {
        if (
          response.data[i].isAu === true &&
          response.data[i].status === "Active"
        ) {
          newArrAU.push(response.data[i]);
        }
      }
      setallValAU(newArrAU);

      var newArrSU = [];
      for (var j = 0; j < response.data.length; j++) {
        if (
          response.data[j].isSu === true &&
          response.data[j].status === "Active"
        ) {
          newArrSU.push(response.data[j]);
        }
      }
      setallValSU(newArrSU);
      debugger;
      //logic for btn show/not
      if (
        props.location.state.current.uniqueIdentifier === "single-yearly" ||
        props.location.state.current.uniqueIdentifier === "single-monthly"
      ) {
        if (newArrAU.length <= 1 && newArrSU.length <= 1) {
          setbtnDisabled(true);
        } else {
          setbtnDisabled(false);
        }
      } else if (
        props.location.state.current.uniqueIdentifier === "couple-yearly" ||
        props.location.state.current.uniqueIdentifier === "couple-monthly"
      ) {
        if (newArrAU.length <= 2 && newArrSU.length <= 2) {
          setbtnDisabled(true);
        } else {
          setbtnDisabled(false);
        }
      }
    });
  }, [uuid]);

  useEffect(() => {
    getFamilyDetails();
  }, []);

  const checkedBoxAU = (event) => {
    var newArr = [];
    var newArrValue = [];
    if (event.target.checked) {
      newArr.push(...newArrayAU, {
        index: event.target.value,
        id: event.target.id,
      });
      setnewArrayAU(newArr);
    } else {
      for (var i = 0; i < newArrayAU.length; i++) {
        if (newArrayAU[i].index === event.target.value) {
          newArrayAU.splice(i, 1);
          newArrValue.push(...newArrayAU);
          setnewArrayAU(newArrValue);
        }
      }
    }
  };
  console.log(newArrayAU);
  console.log(newArraySU);
  const checkedBoxSU = (event) => {
    var newArr = [];
    var newArrValue = [];
    if (event.target.checked) {
      newArr.push(...newArraySU, {
        index: event.target.value,
        id: event.target.id,
      });
      setnewArraySU(newArr);
    } else {
      for (var i = 0; i < newArraySU.length; i++) {
        if (newArraySU[i].index === event.target.value) {
          newArraySU.splice(i, 1);
          newArrValue.push(...newArraySU);
          setnewArraySU(newArrValue);
        }
      }
    }
  };

  useEffect(() => {
    var dateCheck = new Date().getFullYear();
    let st = new Date("01-01-" + dateCheck).getTime();
    // get family details
    UserService.getUserSingleFamilyDetails(uuid, UserDetails.id).then(
      (response) => {
        UserService.getSubsciptionStripe(
          response.FamilyData.Family.Family_Subscription.stripeSubscriptionId
        ).then((res) => {
          settrialCheck(res);
          settrialCheck1(res.items.data[0]);
        });
      },
      (error) => {}
    );
  }, []);

  const newArrCreation = () => {
    setloader(true);
    let arrayAU = [];
    let arraySU = [];
    for (let i = 0; i < newArrayAU.length; i++) {
      arrayAU.push(parseInt(newArrayAU[i].id));
    }
    for (let j = 0; j < newArraySU.length; j++) {
      arraySU.push(parseInt(newArraySU[j].id));
    }

    //bulk user remove api call
    debugger;
    UserService.bulkRemoval(uuid, arrayAU, arraySU).then((res) => {
      UserService.downgradeSubscription(
        uuid,
        props.location.state.current.id,
        props.location.state.stripeCusID.SubscriptionId
      ).then((response) => {
        let subsciptionData = {
          trial_end: "now",
          proration_behavior: "always_invoice",
          billing_cycle_anchor: "now",
          "items[0][plan]": props.location.state.current.stripePriceId,
          "items[0][id]": trialCheck1.id,
        };
        debugger;
        UserService.updateSubsciptionStripe(
          subsciptionData,
          trialCheck.id
        ).then((response) => {
          debugger;
          if (response) {
            setSuccessToast(true);
            setShowToast(true);
            setToastMessage("Subscription Downgraded successfully");
            setTimeout(() => {
              history.push({
                pathname: `/dashboard/${uuid}`,
              });
            }, 3000);
          }
        });
      });
    });
  };

  useEffect(() => {
    if (allFamilyUsers.length > 0) {
      if (
        props.location.state.current.uniqueIdentifier === "single-yearly" ||
        props.location.state.current.uniqueIdentifier === "single-monthly"
      ) {
        if (
          allValAU.length - newArrayAU.length <= 1 &&
          allValSU.length - newArraySU.length <= 1
        ) {
          setbtnDisabled(true);
        } else {
          setbtnDisabled(false);
        }
      } else if (
        props.location.state.current.uniqueIdentifier === "couple-yearly" ||
        props.location.state.current.uniqueIdentifier === "couple-monthly"
      ) {
        if (
          allValAU.length - newArrayAU.length <= 2 &&
          allValSU.length - newArraySU.length <= 2
        ) {
          setbtnDisabled(true);
        } else {
          setbtnDisabled(false);
        }
      }
    }
  }, [newArrayAU]);

  useEffect(() => {
    if (allFamilyUsers.length > 0) {
      if (
        props.location.state.current.uniqueIdentifier === "single-yearly" ||
        props.location.state.current.uniqueIdentifier === "single-monthly"
      ) {
        if (
          allValAU.length - newArrayAU.length <= 1 &&
          allValSU.length - newArraySU.length <= 1
        ) {
          setbtnDisabled(true);
        } else {
          setbtnDisabled(false);
        }
      } else if (
        props.location.state.current.uniqueIdentifier === "couple-yearly" ||
        props.location.state.current.uniqueIdentifier === "couple-monthly"
      ) {
        if (
          allValAU.length - newArrayAU.length <= 2 &&
          allValSU.length - newArraySU.length <= 2
        ) {
          setbtnDisabled(true);
        } else {
          setbtnDisabled(false);
        }
      }
    }
  }, [newArraySU]);

  console.log(allFamilyUsers);

  return (
    <Container>
      <ToastBlockContainer
        successToast={successToast}
        showToast={showToast}
        setShowToast={setShowToast}
        toastMessage={toastMessage}
      />

      {loading ? (
        <>
          <div className="d-flex" style={{ minHeight: "calc(100vh - 17rem)" }}>
            <Loading />
          </div>
        </>
      ) : (
        <>
          <Row className="justify-content-center gy-0 mb-6rem">
            <Col xl="21" xxl="18">
              <h1 className="lh-base mb-4">Downgrade Subscription</h1>
              <section className="bg-white p-4 p-md-6 shadow rounded-4">
                <section>
                  <h2 className="mb-3">Main Users in Family</h2>
                  <div className="mb-6">
                    {allFamilyUsers && allFamilyUsers.length !== 0 ? (
                      allFamilyUsers.map(
                        (userList, index) =>
                          userList.isAu === true &&
                          userList.status === "Active" && (
                            <span key={index}>
                              <Col
                                md="14"
                                lg="12"
                                className="d-flex flex-column flex-sm-row  gap-2 fs-14 manage-users-card "
                              >
                                <span style={{ marginTop: "3px" }}>
                                  <input
                                    type="checkbox"
                                    id={userList.id}
                                    onClick={(event) => checkedBoxAU(event)}
                                    value={index}
                                  ></input>
                                </span>
                                <div>
                                  <span className="fw-semibold">
                                    {userList.User.firstName === "null" ? (
                                      <span></span>
                                    ) : (
                                      userList.User.firstName
                                    )}{" "}
                                    {userList.User.lastName === "null" ? (
                                      <span></span>
                                    ) : (
                                      userList.User.lastName
                                    )}
                                  </span>
                                  <span className="">
                                    {userList.User.firstName !== "null" ? (
                                      <div className="">
                                        {userList.User.email}
                                      </div>
                                    ) : (
                                      <div className="">
                                        {userList.User.email}
                                      </div>
                                    )}
                                  </span>
                                </div>
                              </Col>
                            </span>
                          )
                      )
                    ) : (
                      <div>No Main Users found</div>
                    )}
                    {allFamilyUsers.filter(
                      (user) => user.isAu === true && user.status === "Active"
                    ).length === 0 && <div>No Support Users found</div>}
                  </div>
                </section>
                <hr className="my-3" />
                <section>
                  <h2 className="mb-3">Support Users in Family</h2>
                  <div className="mb-6">
                    {allFamilyUsers && allFamilyUsers.length !== 0 ? (
                      allFamilyUsers.map(
                        (userList, index) =>
                          userList.isSu === true &&
                          userList.status === "Active" && (
                            <span key={index}>
                              <Col
                                md="14"
                                lg="12"
                                className="d-flex flex-column flex-sm-row  gap-2 fs-14 manage-users-card "
                              >
                                <span style={{ marginTop: "3px" }}>
                                  <input
                                    type="checkbox"
                                    onClick={(event) => checkedBoxSU(event)}
                                    value={index}
                                    id={userList.id}
                                  ></input>
                                </span>
                                <div>
                                  <span className="AU-SU-Text-downSub">
                                    {userList.User.firstName === "null" ? (
                                      <span></span>
                                    ) : (
                                      userList.User.firstName
                                    )}{" "}
                                    {userList.User.lastName === "null" ? (
                                      <span></span>
                                    ) : (
                                      userList.User.lastName
                                    )}
                                  </span>
                                  <span>
                                    {userList.User.firstName !== "null" ? (
                                      <div className="AU-SU-TextEmail-downSub">
                                        {userList.User.email}
                                      </div>
                                    ) : (
                                      <div className="AU-SU-TextEmail-downSub">
                                        {userList.User.email}
                                      </div>
                                    )}
                                  </span>
                                </div>
                              </Col>
                            </span>
                          )
                      )
                    ) : (
                      <div>No Support Users found</div>
                    )}
                    {allFamilyUsers.filter(
                      (user) => user.isSu === true && user.status === "Active"
                    ).length === 0 && <div>No Support Users found</div>}
                  </div>
                </section>
                <hr className="my-3" />
                <section className="mb-6">
                  <h2 className="mb-3">Present Plan</h2>
                  <div className="">
                    <p className="d-flex justify-content-between mb-1">
                      <span className="">
                        {(props.location.state.previous.uniqueIdentifier
                          ? props.location.state.previous.uniqueIdentifier
                          : props.location.state.previous.uniqueIden.split(
                              "-"
                            )[0]
                        )
                          .charAt(0)
                          .toUpperCase() +
                          (props.location.state.previous.uniqueIdentifier
                            ? props.location.state.previous.uniqueIdentifier
                            : props.location.state.previous.uniqueIden.split(
                                "-"
                              )[0]
                          ).slice(1)}{" "}
                        {(props.location.state.previous.uniqueIdentifier
                          ? props.location.state.previous.uniqueIdentifier
                          : props.location.state.previous.uniqueIden.split(
                              "-"
                            )[1]
                        )
                          .charAt(0)
                          .toUpperCase() +
                          (props.location.state.previous.uniqueIdentifier
                            ? props.location.state.previous.uniqueIdentifier
                            : props.location.state.previous.uniqueIden.split(
                                "-"
                              )[1]
                          ).slice(1)}
                      </span>
                    </p>
                    <p>
                      <span>
                        0
                        {props.location.state.previous.availableSeats ||
                          props.location.state.previous.availableS}{" "}
                        Main Users
                      </span>
                      <span className="line-downSub"> | </span>
                      <span>
                        0
                        {props.location.state.previous.availableSeats ||
                          props.location.state.previous.availableS}{" "}
                        Support Users
                      </span>
                    </p>
                  </div>
                </section>
                <hr className="my-3" />
                <section className="mb-6">
                  <h2 className="mb-3">Selected Plan</h2>
                  <p className="d-flex justify-content-between mb-1">
                    <span className="">
                      {props.location.state.current.uniqueIdentifier
                        .split("-")[0]
                        .charAt(0)
                        .toUpperCase() +
                        props.location.state.current.uniqueIdentifier
                          .split("-")[0]
                          .slice(1)}{" "}
                      {props.location.state.current.uniqueIdentifier
                        .split("-")[1]
                        .charAt(0)
                        .toUpperCase() +
                        props.location.state.current.uniqueIdentifier
                          .split("-")[1]
                          .slice(1)}
                    </span>
                  </p>
                  <p>
                    <span>
                      0
                      {props.location.state.current.availableSeats ||
                        props.location.state.current.availableS}{" "}
                      Main Users
                    </span>
                    <span className="line-downSub"> | </span>
                    <span>
                      0
                      {props.location.state.current.availableSeats ||
                        props.location.state.current.availableS}{" "}
                      Support Users
                    </span>
                  </p>
                </section>
                <hr className="my-3" />
                <div className="mb-6 bold-colour fw-semibold">
                  The plan you have selected only allows{" "}
                  {props.location.state.current.availableSeats ||
                    props.location.state.current.availableS}{" "}
                  Main Users &{" "}
                  {props.location.state.current.availableSeats ||
                    props.location.state.current.availableS}{" "}
                  Support Users{" "}
                </div>
                <div
                  className={`btn btn-primary ${
                    btnDisabled ? "" : "disabled"
                  } `}
                  onClick={newArrCreation}
                >
                  <span>
                    Remove selected users and continue{" "}
                    {loader && (
                      <span
                        className="spinner-border spinner-border-sm mr-2"
                        role="status"
                      ></span>
                    )}
                  </span>
                </div>
              </section>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};
export default AccountDowngradeSubscription;
